import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgFreeCancellation = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 18" {...props}>
    <defs>
      <linearGradient
        id="free-cancellation_svg__a"
        x1="50%"
        x2="50%"
        y1="100%"
        y2="0%"
      >
        <stop offset="0%" stopColor="#00E04B" />
        <stop offset="100%" stopColor="#0B95F0" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        fill="url(#free-cancellation_svg__a)"
        d="M7.23 0c.843.095 2.054.804 3.635 2.129 1.01.774 2.207 1.219 3.591 1.333.22 5.681-2.163 10.028-7.148 13.878-.058.026-.107.026-.146 0C2.177 13.49-.206 9.143.014 3.462c1.318-.109 2.467-.517 3.446-1.225C5.092.845 6.352.1 7.239 0H7.23z"
        transform="translate(0 .016)"
      />
      <path stroke="#FFF" d="m4.228 8.667 3.007 2.426 3.878-4.859" />
    </g>
  </svg>
);
const Memo = memo(SvgFreeCancellation);
export default Memo;
